// https://vuex.vuejs.org/en/mutations.html
export default {
  ADD_CANCEL_TOKEN (state, token) {
    state.cancelTokens.push(token)
  },

  CLEAR_CANCEL_TOKENS (state) {
    state.cancelTokens = []
  },

  SET_PRINTER (state, printer) {
    state.printer = printer
  },

  SET_MINI (state) {
    state.isMini = !state.isMini
  },

  SET_ONLINE (state, isOnline) {
    state.isOnline = isOnline
  },

  SET_SHOW_FULL_CATALOG (state, showFullCatalog) {
    state.showFullCatalog = showFullCatalog
  },

  SET_FULLSCREEN (state, isFullScreen) {
    state.isFullScreen = isFullScreen
  },

  SET_IDENTIFIER (state, identifier) {
    state.identifier = identifier
  },

  SET_CASH_REGISTER (state, cashRegister) {
    state.cashRegister = cashRegister
  },

  SET_PRODUCTS (state, products) {
    state.products = products
  },

  SET_PRODUCT_STOCKS (state, stocks) {
    state.stocks = stocks
    state.products.forEach((product, i) => {
      let productStock = stocks.find(x => x.productId === product.id)
      state.products.splice(i, 1, { ...state.products[i], storeStock: productStock })
    })
  },

  SET_CUSTOMERS (state, customers) {
    state.customers = customers
  },

  SET_QZTRAY_INSTALLED (state, isInstalled) {
    state.isQzTrayInstalled = isInstalled
  },

  SET_INVENTORY_COUNTS (state, inventoryCounts) {
    state.inventoryCounts = inventoryCounts
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js